import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class DataProcessingService {
    fitlerParams(params: any) {
        const filteredParams: any = {};
        if (params) {
            Object.keys(params).forEach(key => {
                const value = params[key];
                if (
                    value !== undefined &&
                    value !== null &&
                    !(typeof value === 'string' && value.trim() === '')
                ) {
                    filteredParams[key] = value;
                }
            });

            return filteredParams;
        }
    }





}